import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getDocumentosLista = async () => {
    const res = await getData('/tiposdoc');
    return res
}


export const getDocumentoById = async (id) => {
    const res = await getData(`/tiposdoc/${id}`)
    return res
}

export const postDocumento= async (body) => {
    const res = await postData('/tiposdoc', body)
    return res
}

export const patchDocumento = async (id, body) => {
    const res = await patchData(`/tiposdoc/${id}`, body)
    return res
}

export const deleteDocumento = async (id) => {
    const res = await deleteData(`/tiposdoc/${id}`)
    return res
}